"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _popupSlice = require("../../redux/popupSlice");
var _myaccountSlice = require("../../redux/myaccountSlice");
var _excluded = ["onSuccess"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var withAddPaymentDetailsFinalizationHandler = function withAddPaymentDetailsFinalizationHandler(Component) {
  return function (_ref) {
    var onSuccess = _ref.onSuccess,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var adyenRedirectResult = new URLSearchParams(window.location.search).get('redirectResult');
    var paymentMethodId = new URLSearchParams(window.location.search).get('paymentMethodId');
    (0, _react.useEffect)(function () {
      if (adyenRedirectResult && paymentMethodId) {
        dispatch((0, _myaccountSlice.setActiveTab)(_myaccountSlice.MYACCCOUNT_TABS.paymentInfo));
        dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
          isOpen: true,
          isLoading: true,
          step: _popupSlice.PAYMENT_DETAILS_STEPS.FINALIZE_ADYEN
        }));
      }
    }, []);
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      onSuccess: onSuccess
    }, props));
  };
};
var _default = withAddPaymentDetailsFinalizationHandler;
exports.default = _default;